import { render, staticRenderFns } from "./CreateSpaceTemplate.vue?vue&type=template&id=6ae4d9ba&scoped=true"
import script from "./CreateSpaceTemplate.vue?vue&type=script&lang=js"
export * from "./CreateSpaceTemplate.vue?vue&type=script&lang=js"
import style0 from "./CreateSpaceTemplate.vue?vue&type=style&index=0&id=6ae4d9ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae4d9ba",
  null
  
)

export default component.exports